var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"arcopay-container"}},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameborder":"no","framespacing":"0","border":"0","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }